import { cva } from '@/styled-system/css';

export const tabsPanelRecipe = cva({
  base: {
    padding: 'default',
    focusOutline: true,
  },
  variants: {
    appearance: {
      default: {
        backgroundColor: 'bg.neutral',
      },
      file: {
        backgroundColor: 'bg.neutral',
        borderStyle: 'solid',
        borderWidth: 'default',
        borderColor: 'border.action.neutral.default',
      },
    },
    selected: {
      true: {
        display: 'block',
      },
      false: {
        display: 'none',
      },
    },
    fluid: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      appearance: 'file',
      fluid: false,
      css: {
        borderStartEndRadius: 'Tabs.panel',
      },
    },
  ],
});
